import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import '../styles/Profile.css';

const Profile = () => {
  const { user } = useContext(AuthContext);

  return (
    <div className="profile-page">
      <div className="profile-container">
        <h1>My Profile</h1>
        
        <div className="profile-info">
          <div className="profile-avatar">
            <div className="avatar-circle">
              {user?.name?.charAt(0).toUpperCase() || 'U'}
            </div>
          </div>
          
          <div className="profile-details">
            <div className="detail-item">
              <label>Name:</label>
              <p>{user?.name || 'N/A'}</p>
            </div>
            
            <div className="detail-item">
              <label>Email:</label>
              <p>{user?.email || 'N/A'}</p>
            </div>
            
            <div className="detail-item">
              <label>Member Since:</label>
              <p>{new Date().toLocaleDateString()}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
